// TODO Used for debug screen, remove if not needed anymore
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logCollection: any = [];
let logMiddleware: (message: string) => void = () => undefined;

function preserveLogForDebugging(
  message?: unknown,
  ...optionalParams: unknown[]
) {
  if (typeof message === "string") {
    logMiddleware(message);
  }
  if ((message as any).response) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, prefer-destructuring
    const response = (message as any).response;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, prefer-destructuring
    const url = (message as any).config.url;
    logMiddleware(`
         ${new Date().toISOString()}: Status: ${response?.status}, ${url}
         ${JSON.stringify(response?.data)}
        `);
  } else {
    let entry = "";
    if (message instanceof Error) {
      entry = message.message;
    } else {
      try {
        entry = JSON.stringify(message);
      } catch (stringifyError) {
        const errorObj = new Error("Unknown error");
        entry = errorObj.message;
      }
    }
    logMiddleware(entry);
  }
  if (process.env.REACT_APP_ENABLE_DEVELOPMENT_MODE === "true") {
    logCollection.push(message, ...optionalParams);
  }
}

function debug(message?: unknown, ...optionalParams: unknown[]): void {
  // eslint-disable-next-line no-console
  console.debug(message, optionalParams);
  preserveLogForDebugging(message, optionalParams);
}

function error(message?: unknown, ...optionalParams: unknown[]): void {
  // eslint-disable-next-line no-console
  console.error(message, optionalParams);
  preserveLogForDebugging(message, optionalParams);
}

function info(message?: unknown, ...optionalParams: unknown[]): void {
  // eslint-disable-next-line no-console
  console.info(message, optionalParams);
  preserveLogForDebugging(message, optionalParams);
}

function log(message?: unknown, ...optionalParams: unknown[]): void {
  // eslint-disable-next-line no-console
  console.log(message, optionalParams);
  preserveLogForDebugging(message, optionalParams);
}

function warn(message?: unknown, ...optionalParams: unknown[]): void {
  // eslint-disable-next-line no-console
  console.warn(message, optionalParams);
  preserveLogForDebugging(message, optionalParams);
}

function registerLogMiddleware(middleware: (message: string) => void): void {
  logMiddleware = middleware;
}

const LogService = {
  debug,
  error,
  info,
  log,
  warn,
  logCollection,
  registerLogMiddleware,
};

export default LogService;
